/**
 * Strip special characters from a filename so it is safe to store on the server.
 * Keeps letters, numbers, hyphens, underscores and spaces (spaces become "_"),
 * preserves the extension, and falls back to "file" if nothing remains.
 */
export const sanitizeFileName = (filename) => {
  if (!filename || typeof filename !== "string") return "file";

  const lastDot = filename.lastIndexOf(".");
  const hasExt = lastDot > 0;
  const base = hasExt ? filename.slice(0, lastDot) : filename;
  const ext = hasExt ? filename.slice(lastDot + 1) : "";

  const safeBase =
    base
      .replace(/[^a-z0-9-_ ]/gi, "")
      .trim()
      .replace(/\s+/g, "_") || "file";
  const safeExt = ext.replace(/[^a-z0-9]/gi, "");

  return safeExt ? `${safeBase}.${safeExt}` : safeBase;
};

/** Return a new File with a sanitized name when the original name needs cleaning. */
export const withSanitizedFileName = (file) => {
  if (!file) return file;
  const safeName = sanitizeFileName(file.name);
  if (safeName === file.name) return file;
  return new File([file], safeName, {
    type: file.type,
    lastModified: file.lastModified,
  });
};
